import React from 'react';

const TwoDotsIcon = (props) => (
  <svg {...props} viewBox='0 0 5 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.01418 4C3.12659 4 4.02837 3.10457 4.02837 2C4.02837 0.895431 3.12659 0 2.01418 0C0.901781 0 0 0.895431 0 2C0 3.10457 0.901781 4 2.01418 4ZM2.01418 14C3.12659 14 4.02837 13.1046 4.02837 12C4.02837 10.8954 3.12659 10 2.01418 10C0.901781 10 0 10.8954 0 12C0 13.1046 0.901781 14 2.01418 14Z'
      fill={props.fill}
    />
  </svg>
);

export default TwoDotsIcon;
